<template>
  <div>
    <v-container fluid class="px-6 py-6">
      <v-row>
        <v-stepper
          alt-labels
          elevation="0"
          v-model="e1"
          class="bg-transparent overflow-visible w-100 mx-auto"
        >
          <v-row>
            <v-col cols="12" class="mx-auto mt-3">
              <v-stepper-header class="shadow-0">
                <v-stepper-step step="1" color="#0A3542">
                  <span class="text-secondary font-weight-normal">Project</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="2" color="#0A3542">
                  <span class="text-secondary font-weight-normal">Purpose</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3" color="#0A3542">
                  <span class="text-secondary font-weight-normal">Brands</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="4" color="#0A3542">
                  <span class="text-secondary font-weight-normal"
                    >Competitors</span
                  >
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="5" color="#0A3542">
                  <span class="text-secondary font-weight-normal">Goals</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="6" color="#0A3542">
                  <span class="text-secondary font-weight-normal">Seeds</span>
                </v-stepper-step>
              </v-stepper-header>
            </v-col>
          </v-row>

          <v-row>
            <a
              :href="`/#/pages/research/client/${this.$route.params.clientId}/`"
            >
              <v-btn>Back to client</v-btn>
            </a>
            <v-col lg="8" cols="12" class="mx-auto">
              <v-stepper-items
                class="border-radius-xl overflow-hidden shadow-lg mt-5 mb-9"
              >
                <v-stepper-content
                  step="1"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <h5 class="text-h4 font-weight-normal mb-2">
                            New Keyword Research Project
                          </h5>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                      <v-row class="mt-2">
                        <v-col cols="1" />
                        <v-col cols="5">
                          <v-container fluid>
                            <label class="text-sm font-weight-bolder ms-3">
                              Project name:
                            </label>
                            <v-text-field
                              v-model="projectFormData.projectName"
                              :rules="[v => !!v || 'Project name is required']"
                              hide-details
                              outlined
                              color="rgba(0,0,0,.6)"
                              light
                              placeholder=""
                              class="
                                font-size-input
                                placeholder-lighter
                                border border-radius-md
                                mt-2
                                mb-4
                              "
                            >
                            </v-text-field>
                            <label class="text-sm font-weight-bolder ms-3">
                              Type:
                            </label>
                            <v-radio-group
                              v-model="projectFormData.type"
                              :rules="[v => !!v || 'Project type is required']"
                              class="ms-3 mt-1"
                            >
                              <v-radio label="Website" value="website" />
                              <v-radio
                                label="Market Research"
                                value="market-research"
                              />
                            </v-radio-group>
                            <label> Google Search Console site URL: </label>
                            <v-select
                              :items="siteList"
                              v-model="projectFormData.gsc_site_url"
                              :rules="[v => !!v || 'GSC site URL is required']"
                              :disabled="
                                siteList.length === 0 || siteListLoading
                              "
                              :loading="siteListLoading"
                              :placeholder="
                                siteListLoading
                                  ? 'Loading sites...'
                                  : 'Select a site'
                              "
                              class="
                                input-style
                                font-size-input
                                text-light-input
                                placeholder-light
                                border-radius-md
                                select-style
                                mt-3
                                mb-0
                              "
                            ></v-select>
                            <div
                              v-if="siteList.length === 0 && !siteListLoading"
                              class="mt-2"
                            >
                              <v-alert
                                type="warning"
                                dense
                                text
                                class="text-xs"
                              >
                                <v-icon small class="mr-1"
                                  >mdi-alert-circle</v-icon
                                >
                                Google Search Console sites could not be loaded.
                                Please check your authentication.
                              </v-alert>
                            </div>
                          </v-container>
                        </v-col>
                        <v-col cols="5">
                          <v-container fluid>
                            <label class="text-sm font-weight-bolder ms-3">
                              Subject domain name:
                            </label>
                            <v-text-field
                              v-model="projectFormData.subjectDomain"
                              :rules="[v => !!v || 'Domain name is required']"
                              hide-details
                              outlined
                              color="rgba(0,0,0,.6)"
                              light
                              placeholder="e.g., https://www.domain.com"
                              class="
                                font-size-input
                                placeholder-lighter
                                border border-radius-md
                                mt-2
                                mb-4
                              "
                            >
                            </v-text-field>
                            <label class="text-sm font-weight-bolder ms-3">
                              Geographic area of audience:
                            </label>
                            <v-text-field
                              v-model="projectFormData.geographicArea"
                              :rules="[
                                v => !!v || 'Geographic area is required',
                              ]"
                              hide-details
                              outlined
                              color="rgba(0,0,0,.6)"
                              light
                              placeholder=""
                              class="
                                font-size-input
                                placeholder-lighter
                                border border-radius-md
                                mt-2
                                mb-4
                              "
                            >
                            </v-text-field>
                            <label class="text-sm font-weight-bolder ms-3">
                              Industry or market selector:
                            </label>
                            <v-text-field
                              v-model="projectFormData.industryOrMarket"
                              commentout=":rules=[v => !!v || 'Industry is required']"
                              class="
                                input-style
                                font-size-input
                                text-light-input
                                placeholder-light
                                border-radius-md
                                mt-3
                                mb-0
                              "
                              outlined
                              single-line
                              height="38"
                            ></v-text-field>
                          </v-container>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="text-end">
                      <v-btn
                        :disabled="!step1Valid"
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-2
                          mb-2
                          me-2
                        "
                        color="primary"
                        @click="e1 = 2"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="2"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What's the purpose of the Website or Application?
                          </h5>
                          <p class="text-body text-sm">
                            Be as detailed as you can. If you are struggling for
                            an expansive description, type a brief one and click
                            'Expand with AI'
                          </p>
                          <v-textarea
                            v-model="projectFormData.purpose"
                            :rules="[v => !!v || 'Purpose is required']"
                            solo
                            placeholder="Purpose (if you're doing market research, you can leave this blank)"
                            value=""
                          />
                          <v-btn
                            :ripple="false"
                            :elevation="0"
                            class="
                              font-weight-bold
                              text-xs text-dark
                              btn-light
                              py-5
                              px-6
                              mt-6
                              mb-2
                              ms-2
                            "
                          >
                            Expand with AI
                          </v-btn>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 1"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :disabled="!step2Valid"
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 3"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="3"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What are your brand names?
                          </h5>
                          <p class="text-body text-sm">
                            Be as comprehensive as you can if the name is used
                            as a trademark, even for a specific product.
                          </p>
                          <v-textarea
                            v-model="projectFormData.brandNames"
                            :rules="[v => !!v || 'Brand name is required']"
                            solo
                            placeholder=""
                            value=""
                          />
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 2"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :disabled="!step3Valid"
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 4"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="4"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What are the brand names you compete against?
                          </h5>
                          <p class="text-body text-sm">
                            Be as comprehensive as you can if the name is used
                            as a trademark, even for a specific product.
                          </p>
                          <v-textarea
                            v-model="projectFormData.competitorBrandNames"
                            :rules="[
                              v => !!v || 'Competitor brand(s) required',
                            ]"
                            solo
                            placeholder="Be as comprehensive as you can be, but you can always edit this selection later, so don't sweat it too much."
                            value=""
                          />
                          <v-btn
                            :ripple="false"
                            :elevation="0"
                            class="
                              font-weight-bold
                              text-xs text-dark
                              btn-light
                              py-5
                              px-6
                              mt-6
                              mb-2
                              ms-2
                            "
                          >
                            Expand with AI
                          </v-btn>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 3"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :disabled="!step4Valid"
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 5"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="5"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What's the Conversion Goal?
                          </h5>
                          <p class="text-body text-sm">
                            What action do you want your ideal customer to take?
                          </p>
                          <v-textarea
                            v-model="projectFormData.conversions"
                            :rules="[v => !!v || 'Conversion goal(s) required']"
                            solo
                            placeholder="What I want customers to do.  Here are some examples...
˖  Request information with a form
˖  Make a purchase
˖  Call our office"
                            value=""
                          />
                          <v-btn
                            :ripple="false"
                            :elevation="0"
                            class="
                              font-weight-bold
                              text-xs text-dark
                              btn-light
                              py-5
                              px-6
                              mt-6
                              mb-2
                              ms-2
                            "
                          >
                            Give Me Ideas *
                          </v-btn>
                          <p class="text-body text-xs ml-3 font-italic">
                            * Ideas are generated by AI
                          </p>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 4"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :disabled="!step5Valid"
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 6"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content
                  step="6"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            Seed Keywords
                          </h5>
                          <p class="text-body">
                            Select keywords that will be used as seeds to
                            generate a larger list of keywords that could be
                            useful to rank for. It's recommended to have at
                            least 10 seed keywords, and no more than 15.
                          </p>
                          <p class="text-body">
                            If you wish, we can generate these for you
                            automatically based on the information provided so
                            far.
                          </p>
                          <seeds-get
                            :seeds="projectFormData.seeds"
                            :promptData="seedPromptData"
                            @seedUpdate="projectFormData.seeds = $event"
                          ></seeds-get>
                          <v-checkbox
                            v-model="projectCreationSettings.get_semrush_data"
                            label="Attempt to fetch SEMRUSH data"
                            class="mt-4"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 5"
                      >
                        Prev
                      </v-btn>
                      <v-container
                        class="
                          d-flex
                          justify-end
                          align-center
                          mt-2
                          mb-2
                          me-0
                          py-5
                          px-6
                        "
                      >
                        <div v-if="projectLoading" class="mt-auto">
                          <v-progress-circular
                            class="px-8"
                            indeterminate
                          ></v-progress-circular>
                          <span class="pe-16">Creating project...</span>
                        </div>
                        <v-btn
                          :disabled="!step6Valid"
                          :ripple="false"
                          :elevation="0"
                          class="
                            font-weight-bold
                            text-xs
                            btn-default
                            bg-gradient-default
                          "
                          color="primary"
                          @click="postProject()"
                        >
                          Finish & create project
                        </v-btn>
                      </v-container>
                    </div>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-col>
          </v-row>
        </v-stepper>
      </v-row>
    </v-container>
  </div>
</template>
<script>
  import SeedsGet from './Widgets/SeedsGet.vue'
  export default {
    name: 'ProjectWizard',

    components: {
      SeedsGet,
    },

    data() {
      return {
        projectCreationSettings: {
          get_semrush_data: false,
        },
        e1: 1,
        projectLoading: false,
        siteList: [],
        siteListLoading: false,
        toggle_exclusive: 2,
        country: [
          'Albania',
          'Algeria',
          'Andorra',
          'Angola',
          'Argentina',
          'Brasil',
        ],
        projectTypeInline: null,
        industriesMarkets: [
          'car repair',
          'cycling',
          'auto retailer',
          'legal services',
        ],
        projectFormData: {
          brandNames: 'SuperFork',
          competitorBrandNames: 'Uberfork',
          conversions: 'Purchase, Contact us',
          geographicArea: 'Midwestern US',
          industryOrMarket: 'cycling',
          projectName: 'Eko Sport Biking',
          purpose: 'Create artisinal bicycle forks for mountain biking',
          subjectDomain: 'ekosport.com',
          gsc_site_url: '',
          seeds: [],
          type: 'website',
        },
      }
    },
    created() {
      this.getSiteList()
    },
    methods: {
      postProject() {
        const payload = {
          name: this.projectFormData.projectName,
          project_type: 'keyword_research',
          description: this.projectFormData.purpose,
          domain: this.projectFormData.subjectDomain,
          website_purpose: this.projectFormData.purpose,
          target_audience_geographical_area:
            this.projectFormData.geographicArea,
          industry: this.projectFormData.industryOrMarket,
          brand_names: this.projectFormData.brandNames
            .split(',')
            .map(item => item.trim()),
          client_id: this.$route.params.clientId,
          conversion_goals: this.projectFormData.conversions
            .split(',')
            .map(item => item.trim()),
          seeds: this.projectFormData.seeds,
          gsc_site_url: this.projectFormData.gsc_site_url,
          gads_client_id: '5914249844',
          project_creation_settings: this.projectCreationSettings,
        }
        this.projectLoading = true
        this.apiAddProject(payload)
          .then(data => {
            if (data.status == 'initialized') {
              this.$router.push(
                `/pages/research/client/${this.$route.params.clientId}/new-project/success`
              )
            } else {
              this.consoleLog(
                'error',
                'NewProjects.vue fn(apiAddClient): [status, error]',
                data.status,
                data.message
              )
            }
            this.projectLoading = false
          })
          .catch(error => {
            this.consoleLog(
              'error',
              'NewProjects.vue fn(apiAddRecord): error catch',
              error
            )
            this.projectLoading = false
          })
      },
      getSiteList() {
        this.siteListLoading = true
        this.apiGetGscSiteList()
          .then(data => {
            this.consoleLog(
              'info',
              'NewProjects.vue fn(apiGetSiteList): data',
              data
            )
            console.log(data)
            // Check if the response contains an authentication error
            if (data && data.message === 'Google authentication expired') {
              this.$swal({
                title: 'Google Authentication Expired',
                text: 'Your Google authentication has expired. You need to re-authenticate your Google account to access Google Search Console data.',
                icon: 'warning',
                confirmButtonText: 'I Understand',
                showCancelButton: true,
                cancelButtonText: 'Help',
                customClass: {
                  confirmButton: 'btn bg-gradient-warning',
                  cancelButton: 'btn bg-gradient-info',
                },
              }).then(result => {
                if (result.dismiss === this.$swal.DismissReason.confirm) {
                  this.apiGetGoogleAuthLink().then(url => {
                    window.open(url, '_blank')
                  })
                }
              })
              this.siteList = []
            } else if (data && data.responseError) {
              // Handle other API errors
              this.$swal({
                title: 'Error',
                text: 'Failed to load Google Search Console sites. Please try again later.',
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                  confirmButton: 'btn bg-gradient-danger',
                },
              })
              this.siteList = []
            } else {
              // Success case
              this.siteList = data
            }
            this.siteListLoading = false
          })
          .catch(error => {
            this.consoleLog(
              'error',
              'NewProjects.vue fn(apiGetSiteList): error catch',
              error
            )
            this.$swal({
              title: 'Error',
              text: 'Failed to load Google Search Console sites. Please try again later.',
              icon: 'error',
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: 'btn bg-gradient-danger',
              },
            })
            this.siteList = []
            this.siteListLoading = false
          })
      },
    },
    computed: {
      step1Valid() {
        return (
          !!this.projectFormData.projectName &&
          !!this.projectFormData.type &&
          !!this.projectFormData.subjectDomain &&
          !!this.projectFormData.geographicArea &&
          !!this.projectFormData.industryOrMarket &&
          !!this.projectFormData.gsc_site_url
        )
      },
      step2Valid() {
        return !!this.projectFormData.purpose
      },
      step3Valid() {
        return !!this.projectFormData.brandNames
      },
      step4Valid() {
        return !!this.projectFormData.competitorBrandNames
      },
      step5Valid() {
        return !!this.projectFormData.conversions
      },
      step6Valid() {
        return this.projectFormData.seeds.length > 9
      },
      seedPromptData() {
        return {
          domain: this.projectFormData.subjectDomain,
          purpose: this.projectFormData.purpose,
          audience: this.projectFormData.industryOrMarket, // Fix this by adding audience form
          geo_area: this.projectFormData.geographicArea,
          conversions: this.projectFormData.conversions,
        }
      },
    },
  }
</script>
